import React from 'react'
import { Link, useParams } from 'react-router-dom'

import './Task.css'

function Task({task}) {

  let isSolved = task.is_solved
  
  let { _id } = useParams()
  let text = task.text.split('\r\n')

  
  return (
    <li className="task">
        <h3 className="task__title">{task.name}</h3>
        <h3 className={`task__complexity${task.complexity === 'Hard' ? '_hard' : task.complexity === 'Medium' ? '_medium' : task.complexity === 'Easy' ? '_easy' : ''}`}>
          {task.complexity}
        </h3>
        <div className="task__text-wrapper">

          {
            text.map((p, index) => (
              <p className="task__text" key={index}>{p}</p>))
          }                      
        
        </div>
        {isSolved === true ?
        <Link to={`/training/${task.id}`} className="task__btn-solved">Решено</Link>
        :
        <Link to={`/training/${task.id}`} className="task__btn">Решить</Link>
        }
    </li>
  );
}

export default Task;